/*
* 智慧教务
* */

// 课程申报-申报/审批
const Declare = () => import( /* webpackChunkName: "educationAffairs" */ '@/pages/educationAffairs/views/declare/Declare.vue')
const DeclareList = () => import( /* webpackChunkName: "educationAffairs" */ '@/pages/educationAffairs/views/declare/DeclareList.vue')
const DeclareDetail = () => import( /* webpackChunkName: "educationAffairs" */ '@/pages/educationAffairs/views/declare/DeclareDetail.vue')
const DeclareApplyList = () => import( /* webpackChunkName: "educationAffairs" */ '@/pages/educationAffairs/views/declare/DeclareApplyList.vue')
const DeclareApplyDetail = () => import( /* webpackChunkName: "educationAffairs" */ '@/pages/educationAffairs/views/declare/DeclareApplyDetail.vue')
//成绩档案
const AchievementRecord = () => import( /* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/academicRecords/AchievementRecord.vue')
// 模块成绩
const ShowAchievement = () => import( /* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/achievementManage/ShowAchievement.vue')


// 听课评课
const ListenCommentary = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/listenCommentary/Index.vue')
//考场管理
const ExamManage = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/examManage/ExamManage.vue')
const MyExam = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/examManage/MyExam.vue')
const MyExamHistory = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/examManage/MyExamHistory.vue')
const MyInvigilate = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/examManage/MyInvigilate.vue')
const MyInvigilateHistory = () => import(/* webpackChunkName: "educationAffairs" */'@/pages/educationAffairs/views/examManage/MyInvigilateHistory.vue')
const educationAffairs = [
    {
        path: 'declare',
        name: 'declare',
        component: Declare,
        children: [
            {
                path: 'declareList',
                name: 'declareList',
                component: DeclareList,
            },
            {
                path: 'declareDetail',
                name: 'declareDetail',
                component: DeclareDetail,
            },
            {
                path: 'declareApplyList',
                name: 'declareApplyList',
                component: DeclareApplyList,
            },
            {
                path: 'declareApplyDetail',
                name: 'declareApplyDetail',
                component: DeclareApplyDetail,
            }
        ]
    },
    {
        path: 'AchievementRecord',
        name: 'AchievementRecord',
        component: AchievementRecord,
    },
    {
        path: 'ShowAchievement',
        name: 'ShowAchievement',
        component: ShowAchievement,
    },
    {
        path: 'listenCommentary',
        name: 'listenCommentary',
        component: ListenCommentary
    },
    {
        path: 'ExamManage',
        name: 'ExamManage',
        component: ExamManage,
        children:[
            {
                path: 'MyExam',
                name: 'MyExam',
                component: MyExam
            },
            {
                path: 'MyExamHistory',
                name: 'MyExamHistory',
                component: MyExamHistory
            },
            {
                path: 'MyInvigilate',
                name: 'MyInvigilate',
                component: MyInvigilate
            },
            {
                path: 'MyInvigilateHistory',
                name: 'MyInvigilateHistory',
                component: MyInvigilateHistory
            },
        ]
    },

]
export default educationAffairs
